// Auto-generated by process-images.js - DO NOT EDIT MANUALLY
// Last updated: 2025-07-30T22:41:04.197Z

export const TOKEN_LOGOS = new Set([
  '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
  '0x29219dd400f2bf60e5a23d13be72b486d4038894',
  '0x50c42deacd8fc9773493ed674b675be577f2634b',
  's',
]);

export function hasTokenLogo(address: string): boolean {
  return TOKEN_LOGOS.has(address.toLowerCase());
}